import DetailsInterface from '@/utilities/bid/cost/Interfaces/DetailsInterface'
import WorkCodeInterface from '@/utilities/bid/cost/Containers/Interfaces/WorkCodeInterface'
import ItemContainer from '@/utilities/bid/cost/Containers/ItemContainer'
import ItemInterface from '@/utilities/bid/cost/Containers/Interfaces/ItemInterface'
import CollectionInterface from '@/utilities/bid/cost/Interfaces/CollectionInterface'
import DetailsPanelServiceInterface from '@/utilities/bid/cost/Interfaces/DetailsPanelServiceInterface'

class DetailsPanelService implements DetailsPanelServiceInterface {
  details: DetailsInterface
  workCode: Array<WorkCodeInterface>

  constructor(details: DetailsInterface, workCode: Array<WorkCodeInterface>) {
    this.details = details
    this.workCode = workCode
  }

  getDirectLabour(): Array<CollectionInterface> {
    const container: Array<CollectionInterface> = []

    if (this.details === undefined) {
      return container
    }

    this.details.labour.forEach((item: ItemInterface) => {
      const workCode: WorkCodeInterface | undefined = this.workCode.find((code: any) => code.id === item.workCode)
      if (workCode !== undefined) {
        container.push(new ItemContainer(item, workCode).record())
      }
    })
    return container
  }

  getExpenses(): Array<CollectionInterface> {
    const container: Array<CollectionInterface> = []

    if (this.details === undefined) {
      return container
    }

    this.details.expenses.forEach((item: ItemInterface) => {
      const workCode: WorkCodeInterface | undefined = this.workCode.find((code: any) => code.id === item.workCode)
      if (workCode !== undefined) {
        container.push(new ItemContainer(item, workCode).record())
      }
    })
    return container
  }

  getDataProcessing(): Array<CollectionInterface> {
    const container: Array<CollectionInterface> = []

    if (this.details === undefined) {
      return container
    }

    this.details.processing.forEach((item: ItemInterface) => {
      const workCode: WorkCodeInterface | undefined = this.workCode.find((code: any) => code.id === item.workCode)
      if (workCode !== undefined) {
        container.push(new ItemContainer(item, workCode).record())
      }
    })

    return container
  }

  getAdditionalCost(): Array<CollectionInterface> {
    const container: Array<CollectionInterface> = []

    if (this.details === undefined) {
      return container
    }

    this.details.additional.forEach((item: ItemInterface) => {
      const workCode: WorkCodeInterface | undefined = this.workCode.find((code: any) => code.id === item.workCode)
      if (workCode !== undefined) {
        container.push(new ItemContainer(item, workCode).record())
      }
    })

    return container
  }

  getAll() {
    return {
      labour: this.getDirectLabour(),
      expenses: this.getExpenses(),
      processing: this.getDataProcessing(),
      additional: this.getAdditionalCost(),
    }
  }
}
export default DetailsPanelService
